export default function LoadingSpinner() {
  return (
    <div className="flex justify-center items-center min-h-[200px]" aria-live="polite">
      <div 
        className="w-8 h-8 border-4 border-blue-500 border-t-transparent rounded-full animate-spin"
        role="status"
        aria-label="Loading"
      />
    </div>
  );
}